import React, { useState } from "react";
import styles from "./Contact.module.css";
import Footer from "../../components/Footer/Footer";
import Navbar from "../../components/Navbar/Navbar";
import axios from "axios";
import { toast } from "react-toastify";
import { useAuth } from "../../contexts/AuthContext";

function Contact() {
  const { accessToken } = useAuth();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // show loading
      const requestData = {
        name: formData.name,
        email: formData.email,
        message: formData.message,
      };

      const response = await axios.post(
        `${import.meta.env.VITE_BACKEND_URL}/util/contact-us`,
        requestData,
        {
          headers: {
            Authorization: accessToken,
          },
        }
      );

      if (response.status === 200 && response.data) {
        // show success
        toast.success(
          "Your enquiry is successfully posted. Our team will get back to you at the earliest!"
        );
      } else {
        var errorMsg =
          "Some error occurred while posting your query. Please try again!";
        toast.error(errorMsg);
      }

      // Reset form after submission
      setFormData({ name: "", email: "", message: "" });
    } catch (error) {
      console.error("Error while creating an enquiry: ", error);
      // @TODO: toast
      toast.error(
        "An error occurred while fetching favorite listings. Please try again!"
      );
    } finally {
      // hide loading
    }
  };

  return (
    <div className={styles.responsiveBody}>
      <Navbar />
      <main className={styles.main}>
        <section className={`${styles.heroSection} ${styles.container}`}>
          <h1 className={styles.heroTitle}>Contact Us</h1>
          <p className={styles.heroText}>
            We're here to help and answer any question you might have. We look
            forward to hearing from you.
          </p>
        </section>

        <section className={`${styles.contactSection} ${styles.container}`}>
          <div className={styles.contactInfo}>
            <h2>Get in Touch</h2>
            <p>
              Please use the contact information below to connect with a
              specific office or department that can best meet your needs.
            </p>
            <div className={styles.contactDetails}>
              <div className={styles.contactItem}>
                <i className="bi bi-geo-alt"></i>
                <span>Tampa, FL, USA 33617</span>
              </div>
              <div className={styles.contactItem}>
                <i className="bi bi-telephone"></i>
                <span>+1 (813) 438-9869</span>
              </div>
              <div className={styles.contactItem}>
                <i className="bi bi-envelope"></i>
                <span> Team@firstland.homes</span>
              </div>
            </div>
            <div className={styles.mediaInquiries}>
              <h3>Media Inquiries</h3>
              <p>
                If you are a member of the news media, please use the email
                address below to leave a detailed message. Include your name,
                press affiliation, phone number, questions, and deadline.
              </p>
              <p>Email: Team@FirstLand.homes</p>
            </div>
          </div>

          <form className={styles.contactForm} onSubmit={handleSubmit}>
            <div className={styles.formGroup}>
              <label htmlFor="name">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                placeholder="Your name"
                required
              />
            </div>
            <div className={styles.formGroup}>
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="Your email"
                required
              />
            </div>
            <div className={styles.formGroup}>
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleInputChange}
                placeholder="Your message"
                rows="6"
                required
              ></textarea>
            </div>
            <button type="submit" className={styles.submitBtn}>
              Send Message
            </button>
          </form>
        </section>

        {/* <section className={styles.mapSection}>
          <Map className={styles.map} />
        </section> */}
      </main>

      <Footer />
    </div>
  );
}

export default Contact;
